import { axiosInstance } from './common';

const dataCaptureCache = new Map();
let sessionsListCache = null;

export const getDataCapturesList = () => axiosInstance.get(`/datacapture/list`).then((response) => response.data);

export const getDataCapture = (dataCaptureId) =>
  axiosInstance.get(`/datacapture/${dataCaptureId}`).then((response) => response.data);

export const getCachedDataCapture = async (dataCaptureId) => {
  if (dataCaptureCache.has(dataCaptureId)) {
    return dataCaptureCache.get(dataCaptureId);
  }
  const data = await getDataCapture(dataCaptureId);
  dataCaptureCache.set(dataCaptureId, data);
  return data;
};

export const invalidateDataCaptureCache = (dataCaptureId) => {
  dataCaptureCache.delete(dataCaptureId);
};

export const clearDataCaptureCache = () => {
  dataCaptureCache.clear();
  sessionsListCache = null;
};

export const getCachedSessionsList = async () => {
  if (sessionsListCache) {
    return sessionsListCache;
  }
  const data = await searchDataCaptures({ query: '' });
  sessionsListCache = data;
  return data;
};

export const invalidateSessionsListCache = () => {
  sessionsListCache = null;
};

export const getStreamingLink = (dataCaptureId) =>
  axiosInstance.get(`/datacapture/streaming/${dataCaptureId}`).then((response) => response.data);

export const deleteMultipleDataCaptures = (dataCaptureIds) =>
  axiosInstance.delete(`/datacapture/deleteMultiple`, { data: dataCaptureIds }).then((response) => response.data);

export const searchDataCaptures = (searchParams) =>
  axiosInstance.get(`/datacapture/search`, { params: searchParams }).then((response) => response.data);

export const updateDataCapture = (dataCapture) =>
  axiosInstance.post(`/datacapture/update`, dataCapture).then((response) => response.data);